<template>
  <div class="home">
    <ProgressStep step=0 />
    <h1>Simulateur d'éligibilité</h1>
    <p>
      Vérifie en quelques minutes ton éligibilité à la Bourse Y NOT
    </p>
    <p>
      Pour y parvenir, il sera nécessaire de demander des
      informations à tes parents, notamment des éléments
      figurant sur le dernier <b>avis d’imposition</b> reçu (avis {{ new Date().getFullYear() -1 }} sur
      l’année {{ new Date().getFullYear() -2 }})
    </p>
    <button @click="$router.push({ name: 'Etape-1' })" class="submit-button" type="submit">Commencer la simulation</button>
    <button @click="leaveCandidature()" class="submit-button-back">
      <img src="assets/icon/fleche-gauche.svg" alt="Étape précédente">
      <span>Quitter le formulaire</span>
    </button>
  </div>
  <Version />
</template>

<script>
// @ is an alias to /src
import ProgressStep from '@/components/ProgressStep.vue'
import Version from '@/components/Version.vue'

export default {
  name: 'Home',
  components: {
    ProgressStep,
    Version
  },
  methods: {
    leaveCandidature () {
      window.location.href = 'https://bourses.yschools.fr/'
    }
  }
}
</script>

<style lang="scss" scoped>
  h1 {
    margin-top: 30px;
  }
  .submit-button {
    display: block;
    justify-content: unset;
    align-items: unset;
  }
  @media screen and (min-width: 585px) {
    h1 {
      margin-top: 61px;
    }
    .submit-button {
      width: fit-content;
    }
  }
</style>
